import 'bootstrap/dist/css/bootstrap.css';
import { useEffect, useState } from 'react';
import Spinner from '../../shared/spinner';
import InputMask from 'react-input-mask';
import { format, parse, subDays } from 'date-fns';
import { Empregador } from '../../shared/model/empregador';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPrint, faCalendarAlt } from '@fortawesome/free-solid-svg-icons';
import { RelatoriosDTO } from '../../shared/dto/relatoriosDTO';
import ArquivoService from '../../services/arquivoService';
import EmpregadorService from '../../services/empregadorService';
import CustomAlert from '../../shared/customAlert';
import { SituacoesOpcoes } from '../../shared/constantes/situacaoEsteira';
import { useVerificaPermissao } from '../../shared/useVerificaPermissao';
import RelatorioService from '../../services/relatorioService';
import RelatoriosAgendadosService from '../../services/relatoriosAgendadosService';
import { AgendarRelatorioDTO } from '../../shared/dto/agendarRelatorioDTO';
import OriginadorService from '../../services/originadorService';
import PromotoraService from '../../services/promotoraService';
import { Originador } from '../../shared/model/originador';
import LayoutRelatorioService from '../../services/layoutRelatorioService';

function ProducaoAnaliticoComponent() {
  useVerificaPermissao();
  const [alert, setAlert] = useState<{ message: string, type: 'success' | 'warning' | 'error' } | null>(null);
  const [loading, setLoading] = useState(false);
  const [showAgendamentoModal, setShowAgendamentoModal] = useState(false);
  const [errorRelatorio, setErrorRelatorio] = useState<string | null>(null);
  const [totalLinhasRelatorio, setTotalLinhasRelatorio] = useState<number | null>(null);

  const [dtBase1, setDtBase1] = useState(format(subDays(new Date(), 15), 'dd/MM/yyyy'));
  const [dtBase2, setDtBase2] = useState(format(new Date(), 'dd/MM/yyyy'));
  const [agendamentoData, setAgendamentoData] = useState(() => {
    const today = new Date();
    return today.toISOString().split('T')[0];
  });

  const [selectTipoRelatorioAnalitico, setSelectTipoRelatorioAnalitico] = useState('CADASTRO');
  const [selectedOrigem, setSelectedOrigem] = useState('');

  const [tiposOrigemOptions, setTiposOrigemOptions] = useState<string[]>([]);

  // --- ESTADOS PARA O DUAL LIST BOX DO ORIGINADOR ---
  const [availableOriginadores, setAvailableOriginadores] = useState<Originador[]>([]);
  const [selectedOriginadores, setSelectedOriginadores] = useState<Originador[]>([]);
  const [selectedToMoveOriginadores, setSelectedToMoveOriginadores] = useState<Originador[]>([]);
  const [selectedFromSelectedOriginadores, setSelectedFromSelectedOriginadores] = useState<Originador[]>([]);

  const [availableOrigens, setAvailableOrigens] = useState<any[]>([]);
  const [selectedOrigens, setSelectedOrigens] = useState<any[]>([]);
  const [selectedToMoveOrigens, setSelectedToMoveOrigens] = useState<any[]>([]);
  const [selectedFromSelectedOrigens, setSelectedFromSelectedOrigens] = useState<any[]>([]);

  const [availableEmpregadores, setAvailableEmpregadores] = useState<Empregador[]>([]);
  const [selectedEmpregadores, setSelectedEmpregadores] = useState<Empregador[]>([]);
  const [selectedToMoveEmpregadores, setSelectedToMoveEmpregadores] = useState<Empregador[]>([]);
  const [selectedFromSelectedEmpregadores, setSelectedFromSelectedEmpregadores] = useState<Empregador[]>([]);

  const situacoesOpcoes = SituacoesOpcoes;
  const [selecionadosSituacao, setSelecionadosSituacao] = useState<String[]>([]);

  // Instância dos serviços
  const arquivoService: ArquivoService = new ArquivoService();
  const relatorioService: RelatorioService = new RelatorioService();
  const empregadorService: EmpregadorService = new EmpregadorService();
  const relatoriosAgendadosService = new RelatoriosAgendadosService();
  const originadorService: OriginadorService = new OriginadorService();
  const promotoraService: PromotoraService = new PromotoraService();

  const [showLayoutModal, setShowLayoutModal] = useState(false);
  const [layoutsDisponiveis, setLayoutsDisponiveis] = useState<any[]>([]);
  const [idLayoutSelecionado, setIdLayoutSelecionado] = useState<number | null>(null);

  // Instancie o novo serviço
  const layoutRelatorioService = new LayoutRelatorioService();

  const abrirModalEscolhaLayout = async () => {
    if (selectedOrigens.length <= 0) return setAlert({ message: 'Selecione ao menos uma Origem', type: 'warning' });
    if (selectedEmpregadores.length <= 0) return setAlert({ message: 'Selecione ao menos um Empregador', type: 'warning' });
    if (dtBase1 === '' || dtBase2 === '') return setAlert({ message: 'Preencha os campos de datas!', type: 'warning' });

    try {
      setLoading(true);
      const response = await layoutRelatorioService.buscarPorNome('PRODUCAO_ANALITICO');
      const dadosLayout = Array.isArray(response.data) ? response.data : [response.data];

      setLayoutsDisponiveis(dadosLayout);

      if (dadosLayout.length === 1) {
        setIdLayoutSelecionado(dadosLayout[0].id);
      } else {
        setIdLayoutSelecionado(null);
      }

      setShowLayoutModal(true);
    } catch (error) {
      console.error("Erro ao carregar layouts:", error);
      setAlert({ message: 'Erro ao carregar layouts de relatório. Verifique o console.', type: 'error' });
    } finally {
      setLoading(false);
    }
  };

  const carregarTiposOrigem = async () => {
    setLoading(true);
    try {
      const response = await arquivoService.listarTiposOrigem();
      const listaTipos = response.data;

      setTiposOrigemOptions(listaTipos);

      if (listaTipos && listaTipos.length > 0) {
        let tipoInicial = listaTipos[0];
        if (listaTipos.includes('MATRIZ')) {
          tipoInicial = 'MATRIZ';
        }
        setSelectedOrigem(tipoInicial);
        listarOrigens(tipoInicial);
      }
      setLoading(false);
    } catch (err) {
      setLoading(false);
      console.error("Erro ao listar tipos de origem", err);
      const fallbackOptions = ['MATRIZ', 'PROMOTORA', 'SUPERVISOR', 'OPERADOR', 'PONTO_VENDA'];
      setTiposOrigemOptions(fallbackOptions);
      setSelectedOrigem('MATRIZ');
      listarOrigens('MATRIZ');
    }
  };

  const listarOrigens = async (origem: string) => {
    setLoading(true);
    try {
      const response = await arquivoService.listarOrigemGenerica(origem);
      setAvailableOrigens(response.data);
      setSelectedOrigens([]);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      console.error(err);
    }
  };

  const listarEmpregadores = async () => {
    setLoading(true);
    try {
      const response = await empregadorService.listarTodosEmpregadoresAtivos();
      setAvailableEmpregadores(response.data);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      console.error(err);
    }
  };

  const listarOriginadores = async () => {
    setLoading(true);
    try {
      const response = await originadorService.listarTodasOriginadoresPorRole();
      setAvailableOriginadores(response.data);
      // setSelectedOriginadores([]); // Comentado para não limpar se recarregar
      setLoading(false);
    } catch (err) {
      setLoading(false);
      console.error(err);
    }
  };

  // --- NOVA LÓGICA: FILTRAR PROMOTORAS AO SELECIONAR ORIGINADOR ---
  useEffect(() => {
    const atualizarPromotorasPorOriginador = async () => {
      // Só executa se o tipo selecionado for PROMOTORA
      if (selectedOrigem === 'PROMOTORA') {

        // Se tiver originadores selecionados, busca filtrado
        if (selectedOriginadores.length > 0) {
          setLoading(true);
          try {
            const idsOriginadores = selectedOriginadores.map(o => o.id);
            const response = await promotoraService.buscarPorOriginador(idsOriginadores);

            // Filtra para não mostrar nas disponíveis as que JÁ estão nas selecionadas (evita duplicidade visual)
            const novasDisponiveis = response.data.filter((p: any) =>
              !selectedOrigens.some((sel: any) => sel.id === p.id)
            );

            setAvailableOrigens(novasDisponiveis);
          } catch (err) {
            console.error("Erro ao filtrar promotoras por originador", err);
            setAlert({ message: 'Erro ao filtrar promotoras', type: 'error' });
          } finally {
            setLoading(false);
          }
        } else {
          // Se o usuário remover todos os originadores, volta a listar TODAS as promotoras (padrão)
          // Isso garante que a lista não fique vazia se o usuário "limpar" o filtro de originadores
          listarOrigens('PROMOTORA');
        }
      }
    };

    atualizarPromotorasPorOriginador();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedOriginadores, selectedOrigem]);
  // --------------------------------------------------------------------

  const gerarRelatorio = async () => {
    // 1. Validação do Layout (Obrigatória agora)
    if (!idLayoutSelecionado) {
      return setAlert({ message: 'Selecione um layout para gerar o Excel!', type: 'warning' });
    }

    // Fecha o modal de escolha antes de iniciar o processo
    setShowLayoutModal(false);
    setLoading(true);

    try {
      // 2. Montagem do DTO com o ID do Layout
      const dto: RelatoriosDTO = new RelatoriosDTO();
      dto.empregadores = selectedEmpregadores;
      dto.tipoOrigemIds = selectedOrigens.map(origem => origem.id);
      dto.dtBase1 = parse(dtBase1, "dd/MM/yyyy", new Date());
      dto.dtBase2 = parse(dtBase2, "dd/MM/yyyy", new Date());
      dto.tipoOrigem = selectedOrigem;
      dto.tipoRelatorioAnalitico = selectTipoRelatorioAnalitico;
      dto.situacaoEsteira = selecionadosSituacao;

      // Atribui o ID do layout selecionado no modal
      dto.idLayout = idLayoutSelecionado;

      if (selectedOrigem === 'PROMOTORA') {
        (dto as any).originadorIds = selectedOriginadores.map(o => o.id);
      }

      // 3. Chamada ao Service (Retorna Blob do Excel)
      const response = await relatorioService.gerarRelatorioProducaoAnalitico(dto);
      const contentType = response.headers['content-type'];

      // 4. Tratamento de erro retornado como texto plano
      if (contentType && contentType.includes('text/plain')) {
        const errorText = typeof response.data.text === 'function'
          ? await response.data.text()
          : response.data;
        setAlert({ message: errorText, type: 'warning' });
        setLoading(false);
        return;
      }

      // 5. Download do Arquivo Dinâmico
      const blob = new Blob([response.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });

      // Tenta recuperar o nome do arquivo enviado pelo Java no Header
      const contentDisposition = response.headers['content-disposition'];
      let fileName = 'Relatorio_Producao.xlsx';
      if (contentDisposition && contentDisposition.includes('filename=')) {
        fileName = contentDisposition.split('filename=')[1].split(';')[0];
      }

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();

      // Limpeza de memória
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

      setLoading(false);
      setAlert({ message: 'Relatório gerado com sucesso!', type: 'success' });

    } catch (err: any) {
      setLoading(false);
      console.error("Erro na geração do relatório:", err);

      // Tratamento de erro 500 (Relatórios Pesados -> Agendamento)
      if (err.response && err.response.status === 500 && err.response.data instanceof Blob) {
        try {
          const errorText = await err.response.data.text();
          const parsed = JSON.parse(errorText);

          if (parsed && typeof parsed === 'object' && 'message' in parsed) {
            setErrorRelatorio(parsed.message);
            setTotalLinhasRelatorio(parsed.totalRows);
          } else {
            setErrorRelatorio(errorText);
          }
        } catch (parseError) {
          setErrorRelatorio('O relatório é muito grande para geração imediata.');
        }
        setShowAgendamentoModal(true);
      } else {
        setAlert({ message: 'Ocorreu um erro inesperado ao gerar o relatório.', type: 'error' });
      }
    }
  };

  const agendarRelatorio = async () => {
    const userId = localStorage.getItem("id") ?? "";

    if (!agendamentoData) {
      setAlert({ message: "Por favor, selecione a data do agendamento.", type: "warning" });
      return;
    }

    // --- INÍCIO DA CORREÇÃO DE DATA ---

    // 1. Pega a data de HOJE e zera as horas para comparar apenas dia/mês/ano
    const nowNormalized = new Date();
    nowNormalized.setHours(0, 0, 0, 0);

    // 2. Cria a data SELECIONADA garantindo o fuso local
    // Isso evita o problema de datas virarem "ontem" devido ao UTC
    const [ano, mes, dia] = agendamentoData.split('-').map(Number);
    const selectedDate = new Date(ano, mes - 1, dia); // Meses no JS são 0-11

    // 3. Faz a validação
    if (selectedDate < nowNormalized) {
      setAlert({ message: "A data de agendamento não pode ser anterior a hoje.", type: "warning" });
      return;
    }
    // --- FIM DA CORREÇÃO DE DATA ---

    const parametros = {
      dtBase1: format(parse(dtBase1, "dd/MM/yyyy", new Date()), "yyyy-MM-dd"),
      dtBase2: format(parse(dtBase2, "dd/MM/yyyy", new Date()), "yyyy-MM-dd"),
      tipoOrigem: selectedOrigem,
      tipoOrigemIds: selectedOrigens.map(o => o.id),
      empregadorIds: selectedEmpregadores.map(e => e.id),
      tipoRelatorioAnalitico: selectTipoRelatorioAnalitico,
      situacaoEsteira: selecionadosSituacao,
      originadorIds: selectedOrigem === 'PROMOTORA' ? selectedOriginadores.map(o => o.id) : null
    };

    const dto: AgendarRelatorioDTO = {
      userId,
      tipoRelatorio: "PRODUCAO-ANALITICO",
      parametros: JSON.stringify(parametros),
      qtdeLinhas: totalLinhasRelatorio ?? 0,
      // Aqui o selectedDate existe e funciona perfeitamente
      programado: selectedDate.toISOString()
    };

    try {
      const response = await relatoriosAgendadosService.solicitarRelatorio(dto);
      if (response.status === 200) {
        setAlert({ message: "Relatório agendado com sucesso!", type: "success" });
      } else {
        setAlert({ message: "Erro ao agendar relatório.", type: "error" });
      }
    } catch (err: any) {
      const msg = err.response?.data || "Erro inesperado ao agendar relatório.";
      setAlert({ message: msg, type: "error" });
      console.error(err);
    } finally {
      setShowAgendamentoModal(false);
      setErrorRelatorio(null);
    }
  };

  useEffect(() => {
    carregarTiposOrigem();
    listarEmpregadores();
    listarOriginadores();
  }, []);

  // --- FUNÇÕES DE MOVIMENTAÇÃO (ORIGEM) ---
  const moveToSelectedOrigens = () => {
    const newSelected = [...selectedOrigens, ...selectedToMoveOrigens];
    const newAvailable = availableOrigens.filter((origem) => !selectedToMoveOrigens.includes(origem));
    setAvailableOrigens(newAvailable);
    setSelectedOrigens(newSelected);
    setSelectedToMoveOrigens([]);
  };

  const moveToAvailableOrigens = () => {
    const newAvailable = [...availableOrigens, ...selectedFromSelectedOrigens];
    const newSelected = selectedOrigens.filter((origem) => !selectedFromSelectedOrigens.includes(origem));
    setAvailableOrigens(newAvailable);
    setSelectedOrigens(newSelected);
    setSelectedFromSelectedOrigens([]);
  };

  const moveAllToSelectedOrigens = () => {
    const newSelected = [...selectedOrigens, ...availableOrigens];
    setSelectedOrigens(newSelected);
    setAvailableOrigens([]);
  };

  const moveAllToAvailableOrigens = () => {
    const newAvailable = [...availableOrigens, ...selectedOrigens];
    setAvailableOrigens(newAvailable);
    setSelectedOrigens([]);
  };

  // --- FUNÇÕES DE MOVIMENTAÇÃO (EMPREGADOR) ---
  const moveToSelectedEmpregadores = () => {
    const newSelected = [...selectedEmpregadores, ...selectedToMoveEmpregadores];
    const newAvailable = availableEmpregadores.filter((empregador) => !selectedToMoveEmpregadores.includes(empregador));
    setAvailableEmpregadores(newAvailable);
    setSelectedEmpregadores(newSelected);
    setSelectedToMoveEmpregadores([]);
  };

  const moveToAvailableEmpregadores = () => {
    const newAvailable = [...availableEmpregadores, ...selectedFromSelectedEmpregadores];
    const newSelected = selectedEmpregadores.filter((empregador) => !selectedFromSelectedEmpregadores.includes(empregador));
    setAvailableEmpregadores(newAvailable);
    setSelectedEmpregadores(newSelected);
    setSelectedFromSelectedEmpregadores([]);
  };

  const moveAllToSelectedEmpregadores = () => {
    const newSelected = [...selectedEmpregadores, ...availableEmpregadores];
    setSelectedEmpregadores(newSelected);
    setAvailableEmpregadores([]);
  };

  const moveAllToAvailableEmpregadores = () => {
    const newAvailable = [...availableEmpregadores, ...selectedEmpregadores];
    setAvailableEmpregadores(newAvailable);
    setSelectedEmpregadores([]);
  };

  // --- FUNÇÕES DE MOVIMENTAÇÃO (ORIGINADOR) ---
  const moveToSelectedOriginadores = () => {
    const newSelected = [...selectedOriginadores, ...selectedToMoveOriginadores];
    const newAvailable = availableOriginadores.filter((o) => !selectedToMoveOriginadores.includes(o));
    setAvailableOriginadores(newAvailable);
    setSelectedOriginadores(newSelected);
    setSelectedToMoveOriginadores([]);
  };

  const moveToAvailableOriginadores = () => {
    const newAvailable = [...availableOriginadores, ...selectedFromSelectedOriginadores];
    const newSelected = selectedOriginadores.filter((o) => !selectedFromSelectedOriginadores.includes(o));
    setAvailableOriginadores(newAvailable);
    setSelectedOriginadores(newSelected);
    setSelectedFromSelectedOriginadores([]);
  };

  const moveAllToSelectedOriginadores = () => {
    const newSelected = [...selectedOriginadores, ...availableOriginadores];
    setSelectedOriginadores(newSelected);
    setAvailableOriginadores([]);
  };

  const moveAllToAvailableOriginadores = () => {
    const newAvailable = [...availableOriginadores, ...selectedOriginadores];
    setAvailableOriginadores(newAvailable);
    setSelectedOriginadores([]);
  };
  // ----------------------------------------------------------------

  function capitalizeFirstLetter(str: string) {
    if (!str) return '';
    const formatted = str.replace(/_/g, ' ');
    return formatted.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase());
  };

  const handleCheckboxChangeSituacao = (opcao: string) => {
    if (selecionadosSituacao.includes(opcao)) {
      setSelecionadosSituacao(selecionadosSituacao.filter(item => item !== opcao));
    } else {
      setSelecionadosSituacao([...selecionadosSituacao, opcao]);
    }
  };

  return (
    <>
      {alert && <CustomAlert message={alert.message} type={alert.type} onClose={() => setAlert(null)} />}

      {showLayoutModal && (
        <div className="modal fade show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1050 }}>
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content border-0 shadow-lg">
              <div className="modal-header bg-dark text-white">
                <h5 className="modal-title fw-bold">Configuração de Colunas</h5>
                <button type="button" className="btn-close btn-close-white" onClick={() => setShowLayoutModal(false)}></button>
              </div>
              <div className="modal-body p-4">
                <div className="alert alert-info border-0 small mb-4">
                  Selecione qual modelo de colunas e nomes você deseja aplicar neste Excel.
                </div>
                <div className="form-group">
                  <label className="fw-bold mb-2">Modelo de Layout:</label>
                  <select
                    className="form-select border-2 shadow-sm"
                    value={idLayoutSelecionado || ''}
                    onChange={(e) => setIdLayoutSelecionado(Number(e.target.value))}
                  >
                    <option value="">Selecione um layout...</option>
                    {/* Garantimos que tratamos como array mesmo se vier um objeto único */}
                    {(Array.isArray(layoutsDisponiveis) ? layoutsDisponiveis : [layoutsDisponiveis]).map((l) => (
                      l && l.id && (
                        <option key={l.id} value={l.id}>
                          {l.tituloArquivo}
                        </option>
                      )
                    ))}
                  </select>
                </div>
              </div>
              <div className="modal-footer bg-light border-0">
                <button className="btn btn-link text-muted fw-bold text-decoration-none" onClick={() => setShowLayoutModal(false)}>CANCELAR</button>
                <button
                  className="btn btn-dark px-4 fw-bold shadow-sm"
                  onClick={gerarRelatorio}
                  disabled={!idLayoutSelecionado}
                >
                  CONFIRMAR E GERAR
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {showAgendamentoModal && (
        <div className="modal fade show d-block" tabIndex={-1} role="dialog" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Agendar Relatório</h5>
                <button type="button" className="close" aria-label="Fechar" onClick={() => setShowAgendamentoModal(false)}>
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <p>{errorRelatorio}</p>
                <p>Deseja agendar o relatório com os filtros preenchidos?</p>
                <div className="form-group">
                  <label htmlFor="dataAgendamento"><b>Data do Agendamento:</b></label>
                  <input
                    id="dataAgendamento"
                    type="date"
                    required
                    className="form-control"
                    value={agendamentoData}
                    onChange={(e) => setAgendamentoData(e.target.value)}
                    min={new Date().toISOString().split('T')[0]}
                  />
                </div>
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={() => setShowAgendamentoModal(false)}>Cancelar</button>
                <button className="btn btn-primary" onClick={agendarRelatorio}>Agendar</button>
              </div>
            </div>
          </div>
        </div>
      )}

      <div className="position-relative m-md-3">
        {loading ? <Spinner loading={loading} /> : (
          <div className="card" style={{ marginTop: '25px' }}>
            <div className="card-header">
              <strong>Relatório de Produção Analítico</strong>
            </div>
            <div className="card-body">
              <div className="row">
                <div className="col-xl" style={{ marginTop: '20px', display: 'flex', justifyContent: 'normal' }}>
                  <label>
                    <input type="radio" name="options" value="cadastro" checked={selectTipoRelatorioAnalitico === 'CADASTRO'}
                      onChange={() => setSelectTipoRelatorioAnalitico('CADASTRO')} style={{ marginRight: '5px' }}
                    />
                    Cadastro
                  </label>
                  <label>
                    <input type="radio" name="options" value="movimentacao" checked={selectTipoRelatorioAnalitico === 'MOVIMENTACAO'}
                      onChange={() => setSelectTipoRelatorioAnalitico('MOVIMENTACAO')} style={{ marginRight: '5px', marginLeft: '10px' }}
                    />
                    Movimentação
                  </label>
                  <label>
                    <input type="radio" name="options" value="integracao" checked={selectTipoRelatorioAnalitico === 'INTEGRACAO'}
                      onChange={() => setSelectTipoRelatorioAnalitico('INTEGRACAO')} style={{ marginRight: '5px', marginLeft: '10px' }}
                    />
                    Integração
                  </label>
                </div>
              </div>
              <div className="row">
                <label style={{ marginRight: '10px', marginTop: '20px' }}>Situação Proposta:</label>
                <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap' }}>
                  {situacoesOpcoes.map((opcao, index) => (
                    <div key={index} style={{ marginRight: '5px' }}>
                      <input type="checkbox" id={opcao} value={opcao} checked={selecionadosSituacao.includes(opcao)} onChange={() => handleCheckboxChangeSituacao(opcao)} />
                      <label htmlFor={opcao} style={{ marginLeft: '5px' }}>{opcao}</label>
                    </div>
                  ))}
                </div>
              </div>
              <div className="" style={{ marginTop: '10px' }}>
                <div className="row">
                  <div className="col-md-2" style={{ paddingLeft: '10px', paddingRight: '10px' }}>
                    <label>Período de Data <span style={{ color: 'red' }}>*</span></label>
                  </div>
                </div>
                <div className="row" style={{ marginTop: '5px' }}>
                  <div className="col-md-4">
                    <thead>
                      <tr>
                        <th style={{ width: "150px" }}><InputMask required mask="99/99/9999" className="form-control" type="text" value={dtBase1} onChange={(e) => setDtBase1((e.target.value).replace(/_/g, ""))} /></th>
                        <th style={{ width: "15px" }}> a </th>
                        <th style={{ width: "150px" }}><InputMask required mask="99/99/9999" className="form-control" type="text" value={dtBase2} onChange={(e) => setDtBase2((e.target.value).replace(/_/g, ""))} /></th>
                      </tr>
                    </thead>
                  </div>
                </div>
                <div className="row" style={{ marginTop: '10px' }}>
                  <div className="col-md-3">
                    <label>Tipo da Origem</label>
                    <select
                      className="form-select"
                      value={selectedOrigem}
                      onChange={(e) => {
                        const novoTipo = e.target.value;
                        setSelectedOrigem(novoTipo);
                        listarOrigens(novoTipo);

                        // SE MUDAR PARA ALGO QUE NÃO SEJA PROMOTORA, LIMPA A SELEÇÃO DE ORIGINADORES
                        if (novoTipo !== 'PROMOTORA') {
                          setSelectedOriginadores([]);
                          setAvailableOriginadores([]);
                          // Opcional: Recarregar availableOriginadores se a lógica do seu sistema exigir
                          listarOriginadores();
                        }
                      }}
                    >
                      {tiposOrigemOptions.map((tipo) => (
                        <option key={tipo} value={tipo}>
                          {capitalizeFirstLetter(tipo)}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>

              {/* --- DUAL LIST BOX PARA ORIGINADOR (SÓ APARECE SE PROMOTORA) --- */}
              {selectedOrigem === 'PROMOTORA' && (
                <div style={{ display: 'flex', marginTop: '10px' }}>
                  <div>
                    <h6>{Originador.DESCRITIVO_GERAL} Disponíveis</h6>
                    <select
                      multiple
                      value={selectedToMoveOriginadores.map((p) => p.id!.toString())}
                      onChange={(e) => {
                        const options = e.target.options;
                        const selected = [];
                        for (let i = 0; i < options.length; i++) {
                          if (options[i].selected) {
                            const item = availableOriginadores.find(p => p.id!.toString() === options[i].value);
                            if (item) selected.push(item);
                          }
                        }
                        setSelectedToMoveOriginadores(selected);
                      }}
                      style={{ width: '575px', height: '180px' }}
                    >
                      {availableOriginadores.map((orig) => (
                        <option key={orig.id} value={orig.id!.toString()}>
                          {orig.id} - {orig.nome!}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                    <button onClick={moveToSelectedOriginadores} style={{ margin: '5px' }}>{'>'}</button>
                    <button onClick={moveAllToSelectedOriginadores} style={{ margin: '5px' }}>{'>>'}</button>
                    <button onClick={moveToAvailableOriginadores} style={{ margin: '5px' }}>{'<'}</button>
                    <button onClick={moveAllToAvailableOriginadores} style={{ margin: '5px' }}>{'<<'}</button>
                  </div>
                  <div>
                    <h6>{Originador.DESCRITIVO_GERAL} Selecionados</h6>
                    <select
                      multiple
                      value={selectedFromSelectedOriginadores.map((p) => p.id!.toString())}
                      onChange={(e) => {
                        const options = e.target.options;
                        const selected = [];
                        for (let i = 0; i < options.length; i++) {
                          if (options[i].selected) {
                            const item = selectedOriginadores.find(p => p.id!.toString() === options[i].value);
                            if (item) selected.push(item);
                          }
                        }
                        setSelectedFromSelectedOriginadores(selected);
                      }}
                      style={{ width: '575px', height: '180px' }}
                    >
                      {selectedOriginadores.map((orig) => (
                        <option key={orig.id} value={orig.id!.toString()}>
                          {orig.id} - {orig.nome!}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              )}

              {/* QUADROS ORIGENS */}
              <div style={{ display: 'flex', marginTop: '10px' }}>
                <div>
                  <h6>{capitalizeFirstLetter(selectedOrigem.toUpperCase() === 'PROMOTORA' ? 'Promotoras' : selectedOrigem.toUpperCase() === 'PONTOVENDA' || selectedOrigem.toUpperCase() === 'PONTO_VENDA' ? 'Pontos de Venda' : selectedOrigem.toUpperCase() + 'es')} Disponíveis</h6>
                  <select
                    multiple
                    value={selectedToMoveOrigens.map((p) => p.id!.toString())}
                    onChange={(e) => {
                      const options = e.target.options;
                      const selected = [];
                      for (let i = 0; i < options.length; i++) {
                        if (options[i].selected) {
                          const origem = availableOrigens.find(p => p.id!.toString() === options[i].value);
                          if (origem) {
                            selected.push(origem);
                          }
                        }
                      }
                      setSelectedToMoveOrigens(selected);
                    }}
                    style={{ width: '575px', height: '180px' }}
                  >
                    {availableOrigens.map((origem) => (
                      <option key={origem.id} value={origem.id!.toString()}>
                        {origem.id} - {origem.nome!}
                      </option>
                    ))}
                  </select>
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                  <button onClick={moveToSelectedOrigens} style={{ margin: '5px' }}>{'>'}</button>
                  <button onClick={moveAllToSelectedOrigens} style={{ margin: '5px' }}>{'>>'}</button>
                  <button onClick={moveToAvailableOrigens} style={{ margin: '5px' }}>{'<'}</button>
                  <button onClick={moveAllToAvailableOrigens} style={{ margin: '5px' }}>{'<<'}</button>
                </div>
                <div>
                  <h6>{capitalizeFirstLetter(selectedOrigem.toUpperCase() === 'PROMOTORA' ? 'Promotoras' : selectedOrigem.toUpperCase() === 'PONTOVENDA' || selectedOrigem.toUpperCase() === 'PONTO_VENDA' ? 'Pontos de Venda' : selectedOrigem.toUpperCase() + 'es')} Selecionados</h6>
                  <select
                    multiple
                    value={selectedFromSelectedOrigens.map((p) => p.id!.toString())}
                    onChange={(e) => {
                      const options = e.target.options;
                      const selected = [];
                      for (let i = 0; i < options.length; i++) {
                        if (options[i].selected) {
                          const origem = selectedOrigens.find(p => p.id!.toString() === options[i].value);
                          if (origem) {
                            selected.push(origem);
                          }
                        }
                      }
                      setSelectedFromSelectedOrigens(selected);
                    }}
                    style={{ width: '575px', height: '180px' }}
                  >
                    {selectedOrigens.map((origem) => (
                      <option key={origem.id} value={origem.id!.toString()}>
                        {origem.id} - {origem.nome!}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div style={{ display: 'flex', marginTop: '10px' }}>
                <div>
                  <h6>Empregadores Disponíveis </h6>
                  < select
                    multiple
                    value={selectedToMoveEmpregadores.map((e) => e.id!.toString())}
                    onChange={(e) => {
                      const options = e.target.options;
                      const selected = [];
                      for (let i = 0; i < options.length; i++) {
                        if (options[i].selected) {
                          const empregador = availableEmpregadores.find(e => e.id!.toString() === options[i].value);
                          if (empregador) {
                            selected.push(empregador);
                          }
                        }
                      }
                      setSelectedToMoveEmpregadores(selected);
                    }}
                    style={{ width: '575px', height: '250px' }}
                  >
                    {
                      availableEmpregadores.map((empregador) => (
                        <option key={empregador.id} value={empregador.id!.toString()} >
                          {empregador.id} - {empregador.nome!}
                        </option>
                      ))
                    }
                  </select>
                </div>
                < div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                  <button onClick={moveToSelectedEmpregadores} style={{ margin: '5px' }}> {'>'} </button>
                  < button onClick={moveAllToSelectedEmpregadores} style={{ margin: '5px' }}> {'>>'} </button>
                  < button onClick={moveToAvailableEmpregadores} style={{ margin: '5px' }}> {'<'} </button>
                  < button onClick={moveAllToAvailableEmpregadores} style={{ margin: '5px' }}> {'<<'} </button>
                </div>
                < div >
                  <h6>Empregadores Selecionados </h6>
                  < select
                    multiple
                    value={selectedFromSelectedEmpregadores.map((e) => e.id!.toString())}
                    onChange={(e) => {
                      const options = e.target.options;
                      const selected = [];
                      for (let i = 0; i < options.length; i++) {
                        if (options[i].selected) {
                          const empregador = selectedEmpregadores.find(e => e.id!.toString() === options[i].value);
                          if (empregador) {
                            selected.push(empregador);
                          }
                        }
                      }
                      setSelectedFromSelectedEmpregadores(selected);
                    }}
                    style={{ width: '575px', height: '250px' }}
                  >
                    {
                      selectedEmpregadores.map((empregador) => (
                        <option key={empregador.id} value={empregador.id!.toString()} >
                          {empregador.id} - {empregador.nome!}
                        </option>
                      ))
                    }
                  </select>
                </div>
              </div>

              <div className="row" style={{ marginTop: '20px', height: '50px', maxWidth: '70%' }}>
                <div className="col-md-3">
                  <button
                    className="input-group-btn"
                    id="App-button-cor-principal"
                    style={{
                      width: '80%', display: 'flex', alignItems: 'center',
                      justifyContent: 'center', border: '1px solid LightGrey',
                      borderRadius: '5px', height: '100%', minWidth: '50px'
                    }}
                    onClick={abrirModalEscolhaLayout}
                  >
                    <a>
                      <FontAwesomeIcon icon={faPrint} style={{ color: 'White', fontSize: 'larger', marginTop: '5px' }} />
                    </a>
                    <strong style={{ color: 'White', marginLeft: '5px', fontSize: 'larger' }}> Gerar Relatório</strong>
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default ProducaoAnaliticoComponent;